import { apiConfig } from '../config';
import { getFetch } from '../fetch';

export function getStackList({ filters, page, pageSize, themeId, grades, showUnpublished }: any) {
    const { apiGetStackList } = apiConfig.getStaticUrls();

    return getFetch(
        apiGetStackList,
        {
            filters: JSON.stringify(filters),
            page,
            pageSize,
            themeId,
            grades: grades ? grades.join(',') : undefined,
            showUnpublished,
        });
}
